import { Outlet, Link } from "react-router-dom";

const PageHeader = () => {
    return (
        <span className="mainHeader legalHeader">
            <div className="mainFrame">
                <h3 className="mainTitle"><Link to="/">Unit<b className="mainTitleBold">HQ</b></Link></h3>
                <div className="headerInsignias">
                    <img src="./USAJROTC.png" alt="USAJROTC" className="headerInsignia" />
                    <img src="./MCJROTC.png" alt="MCJROTC" className="headerInsignia" />
                    <img src="./NJROTC.png" alt="NJROTC" className="headerInsignia" />
                    <img src="./AFJROTC.png" alt="AFJROTC" className="headerInsignia" />
                    <img src="./CGJROTC.png" alt="CGJROTC" className="headerInsignia" />
                    <img src="./SFJROTC.png" alt="SFJROTC" className="headerInsignia" />
                </div>
            </div>
        </span>
    );
}

export default PageHeader;